import {Component, OnDestroy, OnInit} from "@angular/core";
import {FactureClientDto} from "../../../../core/dtos/facturation/clients/factures/facture-client-dto";
import {Subscription} from "rxjs";
import {UtilsService} from "../../../../core/utils/utils.service";
import {
  FacturationClientService,
  GenerateFactureClientSupplier
} from "../../../../core/services/entities/facturation-client.service";
import {Auth2Service} from "../../../../core/services/security/auth2.service";
import {MSG_KEY, MSG_SEVERITY} from "../../../../core/constants";
import {ToastService} from "../../../../core/services/technique/toast.service";
import {GenerateFactureClientDto} from "../../../../core/dtos/facturation/clients/factures/generate-facture-client-dto";
import {TypeFactureClientEnum} from "../../../../core/enums/facturation/client/type-facture-client-enum";
import {ButtonThemeEnum} from "../../../../shared/ui/button/button-theme-enum";
import {LigneFactureClientDisplay} from "./ligne-facture-client-display";
import type {RowPreparedEvent} from 'devextreme/ui/data_grid';

@Component({
    selector: 'yo-facture-client-details-dialog',
    templateUrl: './facture-client-details-dialog.component.html',
    styleUrls: ['./facture-client-details-dialog.component.scss'],
    standalone: false
})
export class FactureClientDetailsDialogComponent implements OnInit, OnDestroy {

  dialogTitle: string;
  factureClient: FactureClientDto;
  generateFactureClient: GenerateFactureClientDto;
  lignesDisplay: LigneFactureClientDisplay[] = [];
  displayDialog: boolean = false;
  fullScreenDialog: boolean = true;
  openDialogSub: Subscription;
  public readonly TypeFactureClientEnum = TypeFactureClientEnum;

  constructor(public utilsSvc: UtilsService,
              public auth2Svc: Auth2Service,
              public toastSvc: ToastService,
              private facturationClientSvc: FacturationClientService) {
  }

  ngOnInit(): void {
    this.openDialogDetailsSubscription();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.openDialogSub)
  }

  openDialogDetailsSubscription = (): void => {
    this.openDialogSub = this.facturationClientSvc.openDialogDetailsFactureClient$
      .subscribe((res: GenerateFactureClientSupplier) => {
        this.dialogTitle = 'Détails de la facture'
        this.displayDialog = true;
        this.factureClient = res.factureClient;
        this.generateFactureClient = res.generateFactureClient;
        this.lignesDisplay = (res.factureClient?.ligneFactureClientList ?? []).reduce((acc, l) => {
          acc.push({
            rowKey: `${l.id}_p`,
            isFraisFixe: false,
            libellePrincipal: l.libelleElementFacturable,
            libellePlc: l.libellePlc,
            libellePrestation: l.libellePrestation,
            libelleRepas: l.libelleRepas,
            libelleRegime: l.libelleRegime,
            libelleFamilleFacturation: l.libelleFamilleFacturation,
            quantite: l.quantite,
            montantUnitaire: l.montantUnitaire,
            montantHT: l.montantHT,
            tauxTVA: l.tauxTVA,
            montantTTC: l.montantTTC
          });
          if (l.codeFraisFixe) {
            acc.push({
              rowKey: `${l.id}_ff`,
              isFraisFixe: true,
              libellePrincipal: l.libelleFraisFixe || l.codeFraisFixe,
              libellePlc: l.libellePlc,
              libellePrestation: l.libellePrestation,
              libelleRepas: l.libelleRepas,
              libelleRegime: l.libelleRegime,
              libelleFamilleFacturation: null,
              quantite: l.quantite,
              montantUnitaire: l.montantUnitaireFraisFixe,
              montantHT: l.montantFraisFixeHT,
              tauxTVA: l.tauxTvaFraisFixe,
              montantTTC: l.montantFraisFixeTTC
            });
          }
          return acc;
        }, [] as LigneFactureClientDisplay[]);
      });
  };

  generateFacture() {
    this.facturationClientSvc.generateFactureClient(this.generateFactureClient).subscribe((response) => {
      if (!this.utilsSvc.isResponseSupplierError(response)) {
        this.facturationClientSvc.announceFactureClientCreated(response.one);
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `La facture a été créée avec succès`);
      }
      this.closeDialog();
    })
  }

  printFacture() {
    this.facturationClientSvc.announceOpenPrintSettings([this.factureClient]);
  }

  toggleFullScreenInvoice = (): void => {
    this.fullScreenDialog = !this.fullScreenDialog;
  }

  closeDialog() {
    this.displayDialog = false;
  }

  onRowPrepared(e: RowPreparedEvent<LigneFactureClientDisplay>): void {
    if (e.rowType === 'data' && e.data?.isFraisFixe) {
      e.rowElement.classList.add('row-frais-fixe');
    }
  }

  public readonly ButtonThemeEnum = ButtonThemeEnum;
}
